// Generated by scripts/update-seeq-icons.js from src/svg/seeq/asset-tree.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcAssetTree = {
  prefix: 'fak',
  iconName: 'asset-tree' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e913',
    'M660.5 655.4h220.1c20.5 0 35.8-15.4 35.9-35.9v-220.1c0-20.5-15.4-35.8-35.9-35.9h-220.1c-20.5 0-35.8 15.4-35.9 35.9v66.5h-291.8v-117.7h97.3c20.5 0 35.8-15.4 35.8-35.9v-281.6c0-20.5-15.4-35.8-35.8-35.8h-281.6c-20.5 0-35.8 15.4-35.9 35.8v281.6c0 20.5 15.4 35.8 35.9 35.9h97.3v527.3c0 25.6 20.5 41 40.9 41h337.9v66.5c0 20.5 15.4 35.8 35.9 35.9h220.1c20.5 0 35.8-15.4 35.9-35.9v-220.1c0-20.5-15.4-35.8-35.9-35.9h-220.1c-20.5 0-35.8 15.4-35.9 35.9v66.5h-291.8v-281.6h291.8v66.6c0 25.6 15.4 41 35.9 41z',
  ],
} satisfies IconDefinition;
